import {faPhone} from '@fortawesome/pro-solid-svg-icons/faPhone';
import {faUser} from '@fortawesome/pro-solid-svg-icons/faUser';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {supportPhoneNumber} from 'models/supportPhoneNumber';
import {Text, View} from 'native-base';
import {useEffect} from 'react';
import {theme} from 'theme';

import PanelContainer from 'components/PanelContainer';
import {useIsMD} from 'hooks/useIsMD';
import {AdobeEvent, useTrackEvent} from 'hooks/useTrackEvent';

export interface PreferenceSelectorNoInfoProps {
  isLoading: boolean;
}

const PreferenceSelectorNoInfo: React.FC<PreferenceSelectorNoInfoProps> = ({
  isLoading,
}) => {
  const {caesarRewards, ghostWhite, lightGray} = theme.colors;
  const isMD = useIsMD();
  const {trackAdobeEvent} = useTrackEvent();

  useEffect(() => {
    trackAdobeEvent({
      event: AdobeEvent.pageLoad,
      page: {
        name: 'mfa secure your account',
      },
    });
  }, []);

  return (
    <PanelContainer
      title="Secure your account"
      bodyText={
        'You have no contact information on file. Please set up your extra layer of security by contacting us.'
      }
      primaryTitle="Contact us"
      onPrimaryPress={() => {
        window.location.href = `tel:${supportPhoneNumber}`;
      }}
      isLoading={isLoading}
    >
      <View
        flexDirection={isMD ? 'row' : 'column'}
        px={isMD ? '24px' : '16px'}
        pt="24px"
        pb={'24px'}
        backgroundColor={ghostWhite}
        borderRadius="8px"
        alignItems="center"
        justifyContent={isMD ? undefined : 'center'}
      >
        <View
          height="90px"
          width="90px"
          borderRadius="50px"
          backgroundColor={lightGray}
          justifyContent="center"
          alignItems="center"
          mr={isMD ? '48px' : undefined}
        >
          <FontAwesomeIcon
            icon={faUser}
            color={caesarRewards}
            style={{
              position: 'relative',
              fontSize: 56,
            }}
          />
        </View>

        <View justifyContent={isMD ? 'left' : 'center'}>
          <Text
            fontSize="18px"
            pt={isMD ? undefined : '16px'}
            pb="16px"
            lineHeight="22px"
            color="#343840"
            fontFamily="heading"
            fontWeight="bold"
            textAlign={isMD ? undefined : 'center'}
            textTransform="uppercase"
          >
            Contact Support
          </Text>
          <View alignItems={isMD ? undefined : 'center'}>
            <Text
              fontFamily="body"
              fontSize="14px"
              color="#343840"
              lineHeight="24px"
            >
              <FontAwesomeIcon
                icon={faPhone}
                color={caesarRewards}
                style={{
                  position: 'relative',
                  fontSize: 14,
                  marginRight: '8px',
                }}
              />
              {supportPhoneNumber}
            </Text>
          </View>
        </View>
      </View>
    </PanelContainer>
  );
};

export default PreferenceSelectorNoInfo;
